(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["emuiLogrocket"] = factory(require("ReactDOM"));
	else
		root["emuiLogrocket"] = factory(root["ReactDOM"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__845__) => {
return 